import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import Badge from '@material-ui/core/Badge';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const ACTIVE_MATCHER = () => true;
const INACTIVE_MATCHER = () => false;

const processPathname = (pathname) => {
  if (pathname && pathname.length && (pathname[pathname.length - 1] === '/')) {
    return pathname.substring(0, pathname.length - 1);
  }
  return pathname;
};

class HorizontalDrawerLink extends React.Component {
  static getRouteState = (props) => {
    const { to, Icon, label, route, location } = props;
    // strip the to location trailing query string
    const index = to.indexOf('?');
    const path = processPathname(index > 0 ? to.substring(0, index) : to);
    const match = processPathname(location.pathname) === path
          || (route.matchChildPaths && (location.pathname.indexOf(path) === 0));
    const { iconWithProps } = route; // Icons will need to be updated at each props change
    return {
      label,
      Icon,
      iconWithProps,
      to,
      active: match ? ACTIVE_MATCHER : INACTIVE_MATCHER,
      id: route.id,
      badge: route.getBadge(props),
    };
  };

  static propTypes = {
    label: PropTypes.string.isRequired,
    Icon: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({}),
    ]).isRequired,
    to: PropTypes.string.isRequired,
    route: PropTypes.shape({
      getBadge: PropTypes.func,
      subscribeBadgeChange: PropTypes.func,
      unsubscribeBadgeChange: PropTypes.func,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    const { route } = props;
    this.state = {
      badge: route.getBadge(props),
    };

    this.routeSub = (badge) => {
      this.setState({ badge });
    };
  }

  static getDerivedStateFromProps(props, state = {}) {
    const newState = HorizontalDrawerLink.getRouteState(props);
    const changed = newState.label !== state.label
            || newState.Icon !== state.Icon
            || newState.to !== state.to
            || newState.active !== state.active
            || newState.badge !== state.badge;
    return changed ? newState : null;
  }

  componentDidMount() {
    const { route } = this.props;
    route.subscribeBadgeChange(this.routeSub);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const changed = nextState.label !== this.state.label
        || nextState.Icon !== this.state.Icon
        || nextState.iconWithProps
        || nextState.to !== this.state.to
        || nextState.active !== this.state.active
        || nextState.badge !== this.state.badge;
    return changed;
  }

  componentWillUnmount() {
    const { route } = this.props;
    route.unsubscribeBadgeChange(this.routeSub);
  }

  render() {
    const { ...rest } = this.props;
    ['badge', 'to', 'Icon', 'label'].forEach((prop) => { delete rest[prop]; });
    const { badge, to, Icon, iconWithProps, label, active, id } = this.state;
    return (
      <NavLink to={to} activeClassName="active-link" isActive={active} id={`secondaryLink${id}`}>
        <ListItem button className={classnames('tuc-drawer-item', badge !== undefined && 'tuc-drawer-item-badged')}>
          {Icon && (
            !iconWithProps ? (
              <ListItemIcon className="tuc-drawer-icon">
                <Icon />
              </ListItemIcon>
            ) : (
              <Icon {...rest} />
            )
          )}
          {badge !== undefined && (
            <Badge badgeContent={badge} max={9999} color="primary">
              <ListItemText className="drawer-label" primary={label} />
            </Badge>
          )}
          {badge === undefined && <ListItemText className="drawer-label" primary={label} />}
        </ListItem>
      </NavLink>
    );
  }
}

export default HorizontalDrawerLink;
